const MENU_ITEMS = [
  {
    text: 'Indicadores',
    icon: 'mdi-briefcase'
  },
  {
    text: 'Sprints',
    icon: 'mdi-briefcase'
  }
]
export default MENU_ITEMS
